export const GA_MEASUREMENT_ID = "G-1FG8RWXL3W";

export function trackPageView(path) {
  if (typeof window.gtag !== "function") {
    return;
  }

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
  });
}
